<fieldset class="is-flex is-flex-direction-column is-gap-2">
  <h3>{{ 'tarificateur.currency.contract' | translate }}</h3>
  <div class="currency-radio is-flex is-flex-direction-column is-justify-content-space-between">
    <label class="is-flex-grow-1">
      <input
        [formControl]="fc"
        type="radio"
        name="currency"
        value="expat_eur"
      />
      <div class="euro box has-text-centered" [innerHTML]="'tarificateur.currency.expat_eur' | translate"></div>
    </label>
    <label class="is-flex-grow-1">
      <input
        [formControl]="fc"
        type="radio"
        name="currency"
        value="expat_usd"
      />
      <div class="dollar box has-text-centered" [innerHTML]="'tarificateur.currency.expat_usd' | translate"></div>
    </label>
    @if (authorizedCfe) {
      <label class="is-flex-grow-1">
        <input
          [formControl]="fc"
          type="radio"
          name="currency"
          value="expat_cfe" />
        <div class="cfe box has-text-centered" [innerHTML]="'tarificateur.currency.expat_cfe' | translate"></div>
      </label>
    }
  </div>
  @if (fc.value === 'expat_cfe') {
    <div class="is-flex is-gap-2 cfe_detail">
      <mat-icon class="blue-icon">info</mat-icon>
      <span [innerHTML]="'tarificateur.currency.expat_cfe_detail' | translate: contactLink"></span>
    </div>
  }
</fieldset>
